
import { Badge } from "@/components/ui/badge";
import { Utensils, Info, Tags } from "lucide-react";

interface MealIngredientsProps {
  ingredients: string[];
  allergens: string[];
  dietaryTags: string[];
}

export const MealIngredients = ({ ingredients, allergens, dietaryTags }: MealIngredientsProps) => {
  return (
    <div className="space-y-4">
      {ingredients.length > 0 && (
        <div>
          <h3 className="font-semibold flex items-center mb-2 text-black">
            <Utensils className="w-4 h-4 mr-2" />
            Ingredients
          </h3>
          <div className="flex flex-wrap gap-2">
            {ingredients.map((ingredient, index) => (
              <Badge key={index} variant="outline" className="bg-gray-50">
                {ingredient}
              </Badge>
            ))}
          </div>
        </div>
      )}

      {dietaryTags.length > 0 && (
        <div>
          <h3 className="font-semibold flex items-center mb-2 text-black">
            <Tags className="w-4 h-4 mr-2" />
            Dietary Tags
          </h3>
          <div className="flex flex-wrap gap-2">
            {dietaryTags.map((tag, index) => (
              <Badge key={index} variant="outline" className="bg-blue-50 text-blue-600 border-blue-200">
                {tag}
              </Badge>
            ))}
          </div>
        </div>
      )}

      {allergens.length > 0 && (
        <div>
          <h3 className="font-semibold flex items-center mb-2 text-black">
            <Info className="w-4 h-4 mr-2" />
            Allergens
          </h3>
          <div className="flex flex-wrap gap-2">
            {allergens.map((allergen, index) => (
              <Badge key={index} variant="outline" className="bg-red-50 text-red-600 border-red-200">
                {allergen}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
